export { default as NumberWidget } from './NumberWidget';
export { default as IconWidget } from './IconWidget';



// WEBPACK FOOTER //
// ./src/components/Widget/index.js